import { Link, Outlet } from 'react-router-dom';
import { AppShell } from '@higgins/ui';
import { sendFeedback } from '../lib/api';
import { msalInstance, signOut } from '../lib/msal';
import helpContent from '../../docs/USERS.md?raw';

export default function Layout() {
  return (
    <AppShell
      title="Site File Sharing"
      homeLink={(p) => <Link to="/" {...p} />}
      subtitle="Send SWMS to a subcontractor"
      width="2xl"
      msal={msalInstance}
      onSignOut={signOut}
      help={helpContent}
      feedback={{ send: sendFeedback, appKey: 'site-file-sharing' }}
      version={import.meta.env.VITE_APP_VERSION}
    >
      <Outlet />
    </AppShell>
  );
}
